import { useCallback, useEffect } from 'react'

import { useBusinessCreateContext } from '../../context/business-create-context'
import useDissolveScreen from '../../hooks/use-dissolve-screen'
import type { BusinessInfoType } from '../../schemas/business-create'
import useBusinessAdditionalInfoStore from '../../store/business-additional-info-store'

import AdditionalInfoAllInfoStep from './additional-info/all-info'
import AdditionalInfoEditInfoTypeStep from './additional-info/edit-info-type'

const BusinessCreateAdditionalInfoStep = () => {
  const { selectedInfoType, setSelectedInfoType } = useBusinessAdditionalInfoStore()
  const { dissolveStyles, dissolveDuration, setDissolve } = useDissolveScreen()
  const { handleNext, setFooterConfig } = useBusinessCreateContext()

  const onSelectInfoType = useCallback(
    (infoType: BusinessInfoType | null) => {
      setDissolve(true)
      setTimeout(() => {
        setSelectedInfoType(infoType)
        setDissolve(false)
      }, dissolveDuration)
    },
    [setDissolve, setSelectedInfoType, dissolveDuration],
  )

  useEffect(() => {
    setFooterConfig(null)
  }, [handleNext, setFooterConfig])

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    handleNext()
  }

  const renderInnerContent = useCallback(() => {
    if (selectedInfoType) {
      return <AdditionalInfoEditInfoTypeStep onBack={() => onSelectInfoType(null)} />
    }

    return <AdditionalInfoAllInfoStep onSelectInfoType={onSelectInfoType} />
  }, [selectedInfoType, onSelectInfoType])

  return (
    <div className="relative flex size-full items-center justify-start pt-[100px]">
      <div
        className="relative flex max-h-[calc(100vh-40px-200px)] w-full flex-col items-center justify-start overflow-y-auto transition-opacity"
        style={dissolveStyles}
      >
        {renderInnerContent()}
        <form id="business-create-form" onSubmit={onSubmit}></form>
      </div>
    </div>
  )
}

export default BusinessCreateAdditionalInfoStep
